<template>
    <div></div>
</template>
<script>
    export default {
        props:{
            param: Object
        },
        jsonld() { 
            let date = new Date(this.param.DATE_CREATE_UNIX * 1000)
            return {
                "@context": "http://schema.org/",
                "@type": "NewsArticle",
                "headline": this.param.NAME,
                "image":    "https://cadflo.ru/" + this.param.PREVIEW_PICTURE,
                "datePublished": date.toISOString(),
                "dateCreated": date.toISOString(),
                "dateModified": date.toISOString(),
                "description": this.param.PREVIEW_TEXT,
                "articleBody": this.param.DETAIL_TEXT    
            }
        }
    };
</script>
<style>
</style>